//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'BrandDesignKitPage',
  components: {
    BaseImg: () => import('@motionelements/core/src/components/ui/BaseImg.vue'),
    PageMeta: () => import('@motionelements/core/src/components/ThePageMeta.vue'),
    ImgWithDarkMode: () => import('@/components/core/elements/ImgWithDarkMode.vue'),
    BrandHero: () => import('@/components/brand-design-kit/BrandHero.vue'),
    BrandKitLogo: () => import('@/components/brand-design-kit/BrandKitLogo.vue'),
    ColumnSection: () => import('@/components/core/elements/ColumnSection.vue'),
    BaseBreadcrumbs: () => import('@/components/core/BaseBreadcrumbs.vue'),
  },
  data() {
    return {
      incorrectUsage: [
        {
          image: 'https://static.moele.me/img/brand/do-not-modify-colors.svg',
          imageDark: 'https://static.moele.me/img/brand/do-not-modify-colors-inverse.svg',
          heading: this.$t(this.$wbr('brand.incorrect_usage_color_text')),
          class: 'border brand-img-full-width',
        },
        {
          image: 'https://static.moele.me/img/brand/do-not-add-shadow.png?auto=format&w=352&dpr=2',
          imageDark: 'https://static.moele.me/img/brand/do-not-add-shadow-inverse.png?auto=format&w=352&dpr=2',
          heading: this.$t(this.$wbr('brand.incorrect_usage_shadow_text')),
          class: 'border brand-img-full-width',
        },
        {
          image: 'https://static.moele.me/img/brand/do-not-add-outline.svg',
          imageDark: 'https://static.moele.me/img/brand/do-not-add-outline-inverse.svg',
          heading: this.$t(this.$wbr('brand.incorrect_usage_outline_text')),
          class: 'border brand-img-full-width',
        },
        {
          image: 'https://static.moele.me/img/brand/do-not-use-gradient.svg',
          imageDark: 'https://static.moele.me/img/brand/do-not-use-gradient-inverse.svg',
          heading: this.$t(this.$wbr('brand.incorrect_usage_gradient_text')),
          class: 'border brand-img-full-width',
        },
        {
          image: 'https://static.moele.me/img/brand/do-not-distort-proportions.svg',
          imageDark: 'https://static.moele.me/img/brand/do-not-distort-proportions-inverse.svg',
          heading: this.$t(this.$wbr('brand.incorrect_usage_distort_text')),
          class: 'border brand-img-full-width',
        },
        {
          image: 'https://static.moele.me/img/brand/do-not-change-rotation.svg',
          imageDark: 'https://static.moele.me/img/brand/do-not-change-rotation-inverse.svg',
          heading: this.$t(this.$wbr('brand.incorrect_usage_rotate_text')),
          class: 'border brand-img-full-width',
        },
        {
          image: 'https://static.moele.me/img/brand/do-not-use-bg-without-contrast.svg',
          heading: this.$t(this.$wbr('brand.incorrect_usage_background_color_text')),
          class: 'brand-img-full-width',
        },
      ],
    };
  },
  computed: {
    pageTitle() {
      return `${this.$t('term.logo') }・${ this.$t('nav.brand_kit')}`;
    },
    pageDescription() {
      return this.$t('brand.page_description');
    },
    breadcrumbList() {
      return [
        {
          name: this.$t('nav.brand_kit'),
          link: this.$link('/brand').fullPath(),
          active: true,
        },
      ];
    },
  },
};
